/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useBadgeStyles = makeStyles(theme => ({
  iconBadge: {
    background: '#E15D29',
    height: '10px',
    width: '10px',
    border: '2px solid #ffffff',
    borderRadius: '50%',
    top: '5px',
    right: '5px',
  },
  textBadge: {
    background: theme.palette.primary.main,
    height: '10px',
    width: '10px',
    border: '2px solid #ffffff',
    borderRadius: '50%',
    top: '2px',
    right: '-2px',
  },
}));
